export class MyDOMElement extends Phaser.GameObjects.DOMElement {

    constructor(scene, x, y, element, classList, innerText, style) {
        super(scene, x, y, element, classList, innerText, style);

        element = document.createElement(element)
        if (innerText) {
            element.innerHTML = innerText;
        }
        if (classList) {
            this.setClassName(classList)
        }
        if (style) {
            this.node.style = style
        }
        scene.add.existing(this);
    }

}